import styled from 'styled-components'

import { white } from '../../../utils/style-utils'

export const Pre = styled.pre`
  white-space: pre-wrap;
  grid-column: span 3;
  color: ${white};
`
